export default "__VITE_ASSET__ChT$C74a__"